"use client";
export const dynamic = "force-dynamic";

import { NotFound } from "@repo/common/client/pages";

export default NotFound;
